import defaultState from './state'
import Vue from 'vue'

export default {
  setMovements: (state, payload) => {
    if (state.movementsCurrentPage === 1) {
      state.movements = payload
    } else {
      state.movements.push(...payload)
    }
  },
  setIsCallingMovements: (state, payload) => {
    state.isCallingMovements = payload
  },
  setMovementsLastPage: (state, payload) => {
    state.movementsLastPage = payload
  },
  incrementMovementsCurrentPage: (state) => {
    state.movementsCurrentPage++
  },
  setIsCallingOffice: (state, payload) => {
    state.isCallingOffice = payload
  },
  setIsCallingTokenizedCards: (state, payload) => {
    state.isCallingTokenizedCards = payload
  },
  setOfficeBalanceInformation: (state, payload) => {
    state.officeBalanceInformation = payload
  },
  setTokenizedCards: (state, payload) => {
    state.tokenizedCards = payload
  },
  setExpenseDashboardData: (state, payload) => {
    state.expenseDashboardData = payload
  },
  setExpenseDataFilters: (state, payload) => {
    state.expenseDataFilters = payload
  },
  clearStoreData: (state, payload) => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      if (!(payload && payload.keep && payload.keep.includes(key))) {
        Vue.set(state, key, initialState[key])
      }
    })
  }
}
